"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zrxApi = void 0;
const caip_1 = require("@shapeshiftoss/caip");
const chain_adapters_1 = require("@shapeshiftoss/chain-adapters");
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const utils_1 = require("../../utils");
const getZrxTradeQuote_1 = require("./getZrxTradeQuote/getZrxTradeQuote");
const fetchFromZrx_1 = require("./utils/fetchFromZrx");
exports.zrxApi = {
    getTradeQuote: async (input, { assertGetEvmChainAdapter }) => {
        const tradeQuoteResult = await (0, getZrxTradeQuote_1.getZrxTradeQuote)(input, assertGetEvmChainAdapter);
        return tradeQuoteResult.map(tradeQuote => {
            return [tradeQuote];
        });
    },
    getUnsignedEvmTransaction: async ({ chainId, from, tradeQuote, supportsEIP1559, assertGetEvmChainAdapter, }) => {
        const { affiliateBps, receiveAddress, slippageTolerancePercentageDecimal, steps } = tradeQuote;
        const { buyAsset, sellAsset, sellAmountIncludingProtocolFeesCryptoBaseUnit } = steps[0];
        // We need to re-fetch the quote from 0x here because actual quote fetches include validation of
        // approvals, which prevent quotes during trade input from succeeding if the user hasn't already
        // approved the token they are getting a quote for.
        // TODO: we'll want to let users know if the quoted amounts change much after re-fetching
        const zrxQuoteResponse = await (0, fetchFromZrx_1.fetchFromZrx)({
            priceOrQuote: 'quote',
            buyAsset,
            sellAsset,
            sellAmountIncludingProtocolFeesCryptoBaseUnit,
            receiveAddress,
            affiliateBps: affiliateBps ?? '0',
            slippageTolerancePercentageDecimal,
        });
        if (zrxQuoteResponse.isErr())
            throw zrxQuoteResponse.unwrapErr();
        const { value, to, data, estimatedGas } = zrxQuoteResponse.unwrap();
        const { gasLimit, ...feeData } = await chain_adapters_1.evm.getFees({
            adapter: assertGetEvmChainAdapter(chainId),
            data,
            to,
            value,
            from,
            supportsEIP1559,
        });
        return {
            to,
            from,
            value,
            data,
            chainId: Number((0, caip_1.fromChainId)(chainId).chainReference),
            // Use the higher amount of the node or the API, as the node doesn't always provide enought gas padding for
            // total gas used.
            gasLimit: bignumber_js_1.default.max(gasLimit, estimatedGas).toFixed(),
            ...feeData,
        };
    },
    checkTradeStatus: utils_1.checkEvmSwapStatus,
};
